import { compact, orderBy, uniq } from 'es-toolkit';
import { map } from 'es-toolkit/compat';
import { AgentSession } from 'interfaces/agentSession';

import { CopilotSessionActivityState } from './hooks/useCopilotChatFlow';

interface MergeVisibleActiveSessionsParams {
  activeSessions: AgentSession[];
  activeSession?: AgentSession;
  activeSessionId?: string | null;
  sessionActivityById?: Record<string, CopilotSessionActivityState>;
  getSessionById: (sessionId: string) => AgentSession | undefined;
}

export const mergeVisibleActiveSessions = ({
  activeSessions,
  activeSession,
  activeSessionId,
  sessionActivityById,
  getSessionById,
}: MergeVisibleActiveSessionsParams): AgentSession[] => {
  const resolvedActiveSessions = map(activeSessions, (session) => {
    if (activeSession?.id === session.id) {
      return activeSession;
    }

    return getSessionById(session.id) || session;
  });
  const resolvedSessionIds = new Set(map(resolvedActiveSessions, 'id'));
  const localSessionIds = uniq(
    compact([activeSessionId, activeSession?.id, ...Object.keys(sessionActivityById || {})])
  );
  const localOnlySessions = orderBy(
    compact(
      map(localSessionIds, (sessionId) => {
        if (resolvedSessionIds.has(sessionId)) {
          return null;
        }

        const localSession = (activeSession?.id === sessionId ? activeSession : null) || getSessionById(sessionId);
        if (!localSession || localSession.archivedAt) {
          return null;
        }

        return localSession;
      })
    ),
    [(session) => session.updatedAt || session.createdAt || ''],
    ['desc']
  );

  return [...localOnlySessions, ...resolvedActiveSessions];
};
